(function () {
  'use strict';
  const C = window.UMCDiscoveryCore;
  if (!C) return;
  const el = (tag, className, text) => { const node = document.createElement(tag); if (className) node.className = className; if (text !== undefined) node.textContent = text; return node; };
  const params = () => new URLSearchParams(location.search);
  class Discovery {
    constructor(root) {
      this.root = root;
      this.config = JSON.parse(root.querySelector('[data-umc-config]').textContent);
      this.latest = new C.LatestRequest();
      this.status = root.querySelector('[data-umc-status]');
      this.retry = root.querySelector('[data-umc-retry]');
      this.pop = () => this.load(params(), false);
      window.addEventListener('popstate', this.pop);
      root.addEventListener('change', event => this.change(event));
      root.addEventListener('click', event => this.click(event));
      root.addEventListener('submit', event => { if (event.target.matches('.filter-form')) event.preventDefault();
        if (event.target.matches('[data-umc-year-form]')) {
          event.preventDefault();
          let state = C.normalize(params());
          for (const [key, value] of new FormData(event.target)) state = C.refine(state, key, value ? [value] : []);
          this.load(C.serialize(state, params()));
        } });
      this.initializeTheme();
      this.boot();
    }
    async boot() {
      if (this.config.source === 'native') {
        if (C.facets.some(key => params().has(key))) {
          try {
            const response = await fetch(this.config.categoriesUrl);
            if (!response.ok) throw new Error('Categories unavailable');
            const categories = await response.json();
            const filters = JSON.parse(this.root.querySelector('[data-umc-native-filters]').textContent);
            const translated = C.toNative(params(), filters, categories);
            history.replaceState({}, '', this.url(translated));
            await this.load(translated, false);
          } catch (error) { this.fail(error); }
        } else if (params().has('year_min') || params().has('year_max')) this.fail(new Error('Native arbitrary year ranges are unavailable'));
      } else await this.load(params(), false);
    }
    initializeTheme() {
      const theme = window.theme;
      if (!theme) return;
      const priorities = ['custom.product_region', 'custom.product_topic', 'ads.product_format', 'custom.style', 'custom.featured_colour', 'custom.published_century', 'custom.catalogue_creator', 'custom.creator', 'custom.orientation', 'filter.v.price'];
      if (this.config.source === 'native') this.root.querySelectorAll('.filter-form').forEach(form => {
        const groups = [...form.querySelectorAll('[data-umc-param]')];
        const rank = node => { const index = priorities.findIndex(key => node.dataset.umcParam.includes(key)); return index < 0 ? priorities.length : index; };
        groups.sort((a, b) => rank(a) - rank(b)).forEach(group => form.append(group));
      });
      theme.collapsibles?.init(this.root);
      const drawer = this.root.querySelector('#FilterDrawer');
      if (drawer && drawer !== this.drawerNode) {
        this.drawerNode = drawer;
        if (!this.drawer) this.drawer = new theme.Drawers('FilterDrawer', 'collection-filters', true);
        else {
          this.drawer.drawer = drawer;
          this.root.querySelectorAll('.js-drawer-open-collection-filters').forEach(button => button.addEventListener('click', event => this.drawer.open(event)));
          drawer.querySelector('.js-drawer-close')?.addEventListener('click', event => this.drawer.close(event));
        }
        theme.FilterDrawer = this.drawer;
      }
      if (drawer) { drawer.setAttribute('role', 'dialog'); drawer.setAttribute('aria-modal', 'true'); drawer.setAttribute('aria-label', drawer.querySelector('.drawer__title')?.textContent.trim() || 'Filters'); }
      // Impulse supplies drawer positioning, dismissal and focus return. Add a complete Tab loop.
      if (drawer && !drawer.dataset.umcFocusBound) { drawer.dataset.umcFocusBound = 'true'; drawer.addEventListener('keydown', event => {
        if (event.key !== 'Tab') return;
        const nodes = [...drawer.querySelectorAll('button, a[href], input, select, summary, [tabindex="0"]')].filter(node => !node.disabled && node.getClientRects().length);
        const first = nodes[0], last = nodes[nodes.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
      }); }
      if (this.config.source === 'native') this.root.querySelectorAll('.price-range').forEach(node => new theme.PriceRange(node, { onChange: form => {
        const next = params(); next.delete('page');
        for (const [key, value] of new URLSearchParams(form)) { if (value) next.set(key, value); else next.delete(key); }
        this.load(next);
      } }));
      theme.reinitProductGridItem?.(this.root);
    }
    nativeState(query) {
      const filters = JSON.parse(this.root.querySelector('[data-umc-native-filters]').textContent);
      const keys = [...new Set([...filters.map(filter => filter.key), ...[...this.root.querySelectorAll('.filter-form input[name]')].map(input => input.name)])].filter(Boolean);
      return C.normalize(query, keys);
    }
    url(query) {
      query.delete('section_id'); query.delete('sections');
      if (this.config.source === 'umc' && this.config.collection) {
        const refined = C.facets.some(key => query.has(key)) || query.has('year_min') || query.has('year_max') || query.has('sort_by');
        if (refined) query.set('view', 'umc-refine');
        else if (query.get('view') === 'umc-refine') query.delete('view');
      }
      return location.pathname + (query.toString() ? '?' + query.toString() : ''); }
    change(event) {
      const target = event.target;
      if (this.config.source === 'native') {
        if (target.matches('#SortBy')) { const next = params(); next.set('sort_by', target.value); next.delete('page'); return this.load(next); }
        if (!target.matches('.filter-form input[type="checkbox"]')) return;
        const next = params(), form = target.closest('form');
        for (const input of form.querySelectorAll('input[type="checkbox"]')) next.delete(input.name);
        for (const [key, value] of new FormData(form)) if (value) next.append(key, value);
        next.delete('page'); this.load(next);
      } else {
        if (!target.matches('[data-umc-facet], [data-umc-sort]')) return;
        let next = C.normalize(params());
        if (target.matches('[data-umc-sort]')) next = C.refine(next, 'sort_by', [target.value]);
        else {
          const key = target.dataset.umcFacet;
          const checked = [...target.closest('form').querySelectorAll('input:checked')].filter(input => input.dataset.umcFacet === key).map(input => input.value);
          next = C.refine(next, key, checked);
        }
        this.load(C.serialize(next, params()));
      }
    }
    click(event) {
      const target = event.target.closest('a, button'); if (!target) return;
      if (target.matches('[data-umc-retry]')) {
        const next = params(); if (this.restartPagination) { next.delete('page'); this.indexVersion = null; this.restartPagination = false; }
        return this.load(next, this.url(next) !== location.pathname + location.search);
      }
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button > 0) return;
      if (target.matches('[data-umc-clear]')) {
        event.preventDefault();
        if (this.config.source === 'native') { const next = params(); for (const key of [...next.keys()]) if (key.startsWith('filter.') || key === 'page') next.delete(key); return this.load(next); }
        return this.load(C.serialize(C.clear(C.normalize(params())), params()));
      }
      if (target.matches('[data-umc-year-clear]')) {
        event.preventDefault(); const state = C.normalize(params()); delete state.year_min; delete state.year_max;
        return this.load(C.serialize({ ...state, page: 1 }, params()));
      }
      if (target.matches('[data-umc-remove]')) {
        event.preventDefault(); const state = C.normalize(params()), key = target.dataset.umcRemove;
        return this.load(C.serialize(C.refine(state, key, (state.filters[key] || []).filter(value => value !== target.dataset.value)), params()));
      }
      if (target.matches('[data-umc-link], .pagination a, .tag-list--active-tags a')) {
        const url = new URL(target.href, location.href);
        if (url.origin !== location.origin || url.pathname !== location.pathname) return;
        event.preventDefault(); if (!target.closest('.pagination')) url.searchParams.delete('page'); this.load(url.searchParams);
      }
    }
    fail(error) {
      this.status.textContent = this.config.labels.error;
      if (error?.message === 'Endpoint not configured') this.status.textContent = this.config.labels.unavailable;
      this.retry.hidden = error?.message === 'Endpoint not configured';
      // Keep previous results, explicitly mark them stale, and remove the old matching-count claim.
      const count = this.root.querySelector('[data-umc-count]'); if (count) count.textContent = '';
      const nativeCount = this.root.querySelector('.collection-filter__item--count'); if (nativeCount) nativeCount.textContent = '';
      this.root.setAttribute('data-umc-error', 'true');
    }
    async load(query, push = true) {
      query = new URLSearchParams(query); query.delete('section_id'); query.delete('sections');
      const request = this.latest.begin();
      const focused = document.activeElement;
      const restoreDrawerFocus = this.drawer?.isOpen;
      const restoreSortFocus = focused?.id === 'SortBy';
      const restoreFilterFocus = focused?.matches?.('.filter-form input[type="checkbox"]') ? { name: focused.name, value: focused.value } : null;
      window.theme?.FilterDrawer?.close();
      if (push && this.url(query) !== location.pathname + location.search) history.pushState({}, '', this.url(query));
      this.root.setAttribute('aria-busy', 'true'); this.root.removeAttribute('data-umc-error');
      this.status.textContent = this.config.labels.loading; this.retry.hidden = true;
      try {
        if (this.config.source === 'native') {
          query = C.serialize(this.nativeState(query), query);
          const url = new URL(this.url(query), location.origin); url.searchParams.set('section_id', this.config.sectionId);
          const response = await fetch(url, { signal: request.signal }); if (!response.ok) throw new Error('Section request failed');
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const content = html.querySelector('[data-umc-content]'); if (!content) throw new Error('Section unavailable');
          if (!this.latest.current(request)) return;
          this.root.querySelector('[data-umc-content]').replaceWith(content); this.initializeTheme();
        } else {
          const state = C.normalize(query);
          let url;
          if (this.config.source === 'fixture' && !this.config.endpoint) url = new URL(this.config.fixtureUrl, location.origin);
          else {
            if (!this.config.endpoint) throw new Error('Endpoint not configured');
            url = new URL(this.config.endpoint, location.origin);
            if (url.origin !== location.origin || !url.pathname.startsWith('/')) throw new Error('Endpoint must be same origin');
            url.search = C.serialize(state).toString();
            if (state.page > 1 && this.indexVersion) url.searchParams.set('index_version', this.indexVersion);
            if (this.config.savedKey) url.searchParams.set('saved_key', this.config.savedKey);
            if (this.config.collection) url.searchParams.set('collection', this.config.collection);
            for (const [key, value] of Object.entries(this.config.context)) url.searchParams.set(key, value);
          }
          const response = await fetch(url, { signal: request.signal, headers: { Accept: 'application/json' } });
          let data = await response.json();
          if (!response.ok) { const error = new Error('Discovery request failed'); error.code = data.error?.code; throw error; }
          if (this.config.source === 'fixture' && !this.config.endpoint) {
            // Fixed fixture only supports its exact query; never pretend it is a full browser query engine.
            if (Object.keys(state.filters).length || state.page > 1 || state.year_min || state.year_max || state.sort) throw new Error('Fixture only supports its initial query');
            data = { ...data, context: this.config.context, scope: { collection: this.config.collection || '', saved_key: this.config.savedKey || '', base_query: {} } };
            if (this.config.collection || this.config.savedKey) throw new Error('Fixed fixture cannot enforce a saved or collection scope');
          }
          C.validateResponse(data, this.config);
          if (state.page === 1 || !this.indexVersion) this.indexVersion = data.index_version;
          const cards = await this.cards(data, request);
          if (!this.latest.current(request)) return;
          this.render(data, cards);
        }
        if (this.latest.current(request)) {
          this.status.textContent = ''; this.retry.hidden = true;
          if (this.config.source === 'native') {
            const focusTarget = restoreDrawerFocus ? this.root.querySelector('.js-drawer-open-collection-filters') : restoreSortFocus ? this.root.querySelector('#SortBy') : restoreFilterFocus ? [...this.root.querySelectorAll('.filter-form input[type="checkbox"]')].find(input => input.name === restoreFilterFocus.name && input.value === restoreFilterFocus.value) : null;
            focusTarget?.focus({ preventScroll: true });
          }
        }
      } catch (error) { if (this.latest.current(request)) { this.restartPagination = error.code === 'stale_index'; this.fail(error); } }
      finally { if (this.latest.current(request)) this.root.setAttribute('aria-busy', 'false'); }
    }
    async cards(data, request) {
      if (data.development_fixture) return data.results.map(product => {
        const wrapper = el('div', 'grid__item grid-product small--one-half medium-up--one-quarter');
        wrapper.append(el('div', 'umc-fixture-card', product.title)); return wrapper;
      });
      const cards = new Array(data.results.length); let cursor = 0;
      await Promise.all(Array.from({ length: Math.min(6, data.results.length) }, async () => {
        while (cursor < data.results.length) {
          const index = cursor++, product = data.results[index];
          const url = new URL(this.config.root.replace(/\/$/, '') + '/products/' + encodeURIComponent(product.handle), location.origin);
          url.searchParams.set('view', 'umc-card');
          if (params().has('preview_theme_id')) url.searchParams.set('preview_theme_id', params().get('preview_theme_id'));
          const response = await fetch(url, { signal: request.signal }); if (!response.ok) throw new Error('Product card unavailable');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const boundary = doc.querySelector('[data-umc-card]'), card = boundary?.querySelector('.grid-product');
          if (!card || boundary.dataset.productHandle !== product.handle || String(card.dataset.productId) !== String(product.id).split('/').pop()) throw new Error('Unexpected product card');
          cards[index] = card;
        }
      }));
      return cards;
    }
    render(data, cards) {
      const grid = el('div', 'grid grid--uniform'); grid.dataset.umcGrid = '';
      cards.forEach(card => grid.append(card));
      const results = this.root.querySelector('[data-umc-results]'); results.replaceChildren(grid);
      if (!cards.length) results.append(el('p', '', this.config.labels.empty));
      const count = this.config.labels[data.total.exact ? (data.total.value === 1 ? 'countOne' : 'count') : 'approximate'];
      this.root.querySelector('[data-umc-count]').textContent = count.replace('__COUNT__', new Intl.NumberFormat(this.config.context.language).format(data.total.value));
      const selectedLabels = data.facets.flatMap(facet => facet.values.filter(value => value.selected).map(value => value.label));
      const heading = data.heading || (this.config.savedKey || this.config.collection || !selectedLabels.length ? this.config.heading : this.config.heading + ': ' + selectedLabels.join(', '));
      this.root.querySelector('[data-umc-heading]').textContent = heading;
      this.root.querySelector('[data-umc-breadcrumb]').textContent = heading;
      const filtersButton = this.root.querySelector('[data-umc-filters-button]'); if (filtersButton) filtersButton.disabled = !data.facets.some(facet => facet.values.length);
      this.renderFacets(data); this.renderChips(data); this.renderPagination(data); this.renderYears(data);
      const sort = this.root.querySelector('[data-umc-sort]'); sort.replaceChildren();
      for (const item of data.capabilities.sorts) { const option = el('option', '', item.label); option.value = item.key; option.selected = item.key === data.query.sort; sort.append(option); }
      sort.disabled = !sort.options.length;
      this.initializeTheme();
    }
    renderYears(data) {
      this.root.querySelector('[data-umc-year-form]')?.remove();
      if (!data.capabilities.year_range) return;
      const form = el('form', 'umc-discovery__years'); form.dataset.umcYearForm = '';
      for (const [key, label] of [['year_min', this.config.labels.yearMin], ['year_max', this.config.labels.yearMax]]) {
        const wrapper = el('label', '', label);
        const input = el('input'); input.type = 'number'; input.min = '1'; input.max = '9999'; input.step = '1'; input.name = key; input.value = data.query[key] || '';
        wrapper.append(input); form.append(wrapper);
      }
      const button = el('button', 'btn btn--tertiary', this.config.labels.apply); button.type = 'submit'; form.append(button);
      this.root.querySelector('[data-umc-results]').before(form);
    }
    renderFacets(data) {
      const containers = [this.root.querySelector('.collection-sidebar'), this.root.querySelector('#FilterDrawer .drawer__scrollable')].filter(Boolean);
      containers.forEach((container, locationIndex) => {
        const form = el('form', 'filter-form');
        data.facets.forEach(facet => {
          const details = el('details', 'umc-facet'); details.open = true;
          details.append(el('summary', 'tag-list__header', facet.label));
          const list = el('ul', 'no-bullets tag-list');
          facet.values.forEach((value, valueIndex) => {
            if (['none', 'unknown', ''].includes(value.key.toLowerCase()) && !value.selected) return;
            const li = el('li', 'tag' + (value.selected ? ' tag--active' : ''));
            const label = el('label', 'tag__checkbox-wrapper text-label');
            const input = el('input', 'tag__input'); input.type = 'checkbox'; input.name = facet.key; input.value = value.key; input.checked = value.selected; input.disabled = value.count === 0 && !value.selected; input.dataset.umcFacet = facet.key;
            input.id = 'umc-' + this.config.sectionId + '-' + locationIndex + '-' + facet.key + '-' + valueIndex;
            label.htmlFor = input.id; label.append(input, el('span', 'tag__checkbox'), el('span', 'tag__text', value.label + ' (' + value.count + ')')); li.append(label); list.append(li);
          });
          details.append(list); form.append(details);
        });
        container.replaceChildren(form);
      });
    }
    renderChips(data) {
      const container = this.root.querySelector('[data-umc-chips]'); container.replaceChildren();
      for (const facet of data.facets) for (const value of facet.values) if (value.selected) {
        const state = C.refine(data.query, facet.key, (data.query.filters[facet.key] || []).filter(key => key !== value.key));
        const link = el('a', 'btn btn--small', value.label + ' ×'); link.href = this.url(C.serialize(state, params())); link.dataset.umcRemove = facet.key; link.dataset.value = value.key;
        link.setAttribute('aria-label', this.config.labels.remove.replace('__VALUE__', value.label)); container.append(link);
      }
      if (data.query.year_min || data.query.year_max) {
        const state = { ...data.query, page: 1 }; delete state.year_min; delete state.year_max;
        const link = el('a', 'btn btn--small', [data.query.year_min, data.query.year_max].filter(Boolean).join('–') + ' ×');
        link.href = this.url(C.serialize(state, params())); link.dataset.umcYearClear = ''; container.append(link);
      }
      if (container.children.length || data.query.year_min || data.query.year_max) { const link = el('a', '', this.config.labels.clear); link.dataset.umcClear = ''; link.href = this.url(C.serialize(C.clear(data.query), params())); container.append(link); }
    }
    renderPagination(data) {
      const nav = this.root.querySelector('[data-umc-pagination]'); nav.replaceChildren();
      const page = data.pagination.page;
      for (const [number, label] of [[page - 1, this.config.labels.previous], [page + 1, this.config.labels.next]]) if (number > 0 && number <= data.pagination.pages) {
        const link = el('a', 'btn btn--tertiary', label); link.dataset.umcLink = ''; link.href = this.url(C.serialize({ ...data.query, page: number }, params())); nav.append(link);
      }
    }
    destroy() { this.latest.cancel(); window.removeEventListener('popstate', this.pop); window.theme?.FilterDrawer?.close(); }
  }
  const mount = scope => scope.querySelectorAll('[data-umc-discovery]').forEach(root => { if (!root.umcDiscovery) root.umcDiscovery = new Discovery(root); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount(document)); else mount(document);
  document.addEventListener('shopify:section:load', event => mount(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-umc-discovery]').forEach(root => root.umcDiscovery?.destroy()));
})();
